import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardText,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap";

//import images
import bill from "assets/images/bill.png";
function EarningReports(props) {
  return (
    <React.Fragment>
      <Row>
        <Col lg={4}>
          <Link to="/tickets">
            <Card className="my-2" color="success" inverse>
              <CardBody>
                <Row className="align-items-center">
                  <Col sm={10}>
                    <p className="font-size-20">
                      <b>Lista de entradas</b>
                    </p>

                    <CardText>Registrar ticket de entrada</CardText>
                  </Col>
                  <Col sm={2}>
                    <div className="mt-4 mt-sm-0">
                      <i className="bx bx-edit bx-lg"></i>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Link>
        </Col>
        {props.group === "Administrador" ||
        props.group === "Gerencia" ||
        props.group === "Veterinario" ? (
          <Col lg={4}>
            <Link to="/departures">
              <Card className="my-2" color="info" inverse>
                <CardBody>
                  <Row className="align-items-center">
                    <Col sm={10}>
                      <p className="font-size-20">
                        <b>Autorización de salida</b>
                      </p>
                      <CardText>Obtener autorización de salida</CardText>
                    </Col>
                    <Col sm={2}>
                      <div className="mt-4 mt-sm-0">
                        <i className="bx bx-file bx-lg"></i>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Link>
          </Col>
        ) : null}
        {props.group === "Administrador" ||
        props.group === "Gerencia" ||
        props.group === "Veterinario" ? (
          <Col lg={4}>
            <Link to="/confiscations">
              <Card className="my-2" color="danger" inverse>
                <CardBody>
                  <Row className="align-items-center">
                    <Col sm={10}>
                      <p className="font-size-20">
                        <b>Decomisos</b>
                      </p>
                      <CardText>Generar boleta de decomiso</CardText>
                    </Col>
                    <Col sm={2}>
                      <div className="mt-4 mt-sm-0">
                        <i className="bx bx-window-close bx-lg"></i>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Link>
          </Col>
        ) : null}
        <Col lg={4}>
          <Link to="/subproducts">
            <Card className="my-2" color="dark" inverse>
              <CardBody>
                <Row className="align-items-center">
                  <Col sm={10}>
                    <p className="font-size-20">
                      <b>Subproductos</b>
                    </p>

                    <CardText>Registrar venta de subproductos</CardText>
                  </Col>
                  <Col sm={2}>
                    <div className="mt-4 mt-sm-0">
                      <i className="bx bx-receipt bx-lg"></i>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Link>
        </Col>
      </Row>
    </React.Fragment>
  );
}

EarningReports.propTypes = {
  group: PropTypes.string,
};

export default EarningReports;
